import { Plan } from 'src/services/responseTypes/displayPlansResponse';
import { mixpanelObject } from 'src/utils/analytics';
import { clearCtaEventsProperty } from 'src/utils/analytics/mixpanel/mixpanelHelper';
import { getLocalStorage } from 'src/utils/browserStorageHandler';
import { USER_TYPE } from 'src/utils/constants/localStorageConstants';

import {
  MIXPANEL_ELEMENT,
  MIXPANEL_DIRECTION,
  MIXPANEL_POP_UP_NAME,
  MIXPANEL_POP_UP_TYPE,
  MIXPANEL_BUTTON_TYPE,
  MIXPANEL_POP_UP_GROUP,
  MIXPANEL_IS_SUBSCRIPTION_FLOW,
  MIXPANEL_ACTUAL_COST,
  MIXPANEL_CONSUMPTION_BUY_PLAN,
  MIXPANEL_CONSUMPTION_SUBSCRIPTION,
  MIXPANEL_COST,
  MIXPANEL_CTA,
  MIXPANEL_CURRENT_SUBSCRIPTION,
  MIXPANEL_NATIVE,
  MIXPANEL_PACK_SELECTED,
  MIXPANEL_TRANSACTION_CURRENCY
} from '../../utils/analytics/mixpanel/mixpanelConstants';
import {
  subscriptionPageViewedEvent,
  subscriptionSelectedEvent,
  popupCTAEvent
} from '../../utils/analytics/mixpanel/mixpanelEventsHelper';

export const fireSubsPageViewedEvent = () => {
  mixpanelObject.setProperty(
    MIXPANEL_POP_UP_NAME,
    MIXPANEL_CONSUMPTION_BUY_PLAN
  );
  mixpanelObject.setProperty(MIXPANEL_POP_UP_TYPE, MIXPANEL_NATIVE);
  mixpanelObject.setProperty(
    MIXPANEL_POP_UP_GROUP,
    MIXPANEL_CONSUMPTION_SUBSCRIPTION
  );
  mixpanelObject.setProperty(MIXPANEL_IS_SUBSCRIPTION_FLOW, true);
  subscriptionPageViewedEvent();
};

export const subscriptionSelectedMixPanel = (
  selectPlan: Plan | null,
  element: string
) => {
  mixpanelObject.setProperty(
    MIXPANEL_PACK_SELECTED,
    `${selectPlan?.id}_${selectPlan?.title}_${selectPlan?.plan_type}`
  );
  mixpanelObject.setProperty(
    MIXPANEL_COST,
    selectPlan?.discount
      ? (selectPlan?.actual_price || selectPlan?.sell_price) -
          (selectPlan?.discount?.discountAmount || 0)
      : selectPlan?.actual_price || selectPlan?.sell_price
  );
  mixpanelObject.setProperty(
    MIXPANEL_CURRENT_SUBSCRIPTION,
    getLocalStorage(USER_TYPE) === 'premium'
  );
  mixpanelObject.setProperty(
    MIXPANEL_TRANSACTION_CURRENCY,
    selectPlan?.currency
  );
  mixpanelObject.setProperty(
    MIXPANEL_ACTUAL_COST,
    selectPlan?.actual_price || 'N/A'
  );
  mixpanelObject.setProperty(MIXPANEL_ELEMENT, element);
  mixpanelObject.setProperty(MIXPANEL_IS_SUBSCRIPTION_FLOW, true);
  subscriptionSelectedEvent();
};

export const mixpanelPopupCTAEvent = (element: string) => {
  // mixpanel Initailization start
  clearCtaEventsProperty(mixpanelObject);
  mixpanelObject[MIXPANEL_ELEMENT] = element;
  mixpanelObject[MIXPANEL_DIRECTION] = 'N/A';
  mixpanelObject[MIXPANEL_POP_UP_NAME] = MIXPANEL_CONSUMPTION_BUY_PLAN;
  mixpanelObject[MIXPANEL_POP_UP_TYPE] = MIXPANEL_NATIVE;
  mixpanelObject[MIXPANEL_BUTTON_TYPE] = MIXPANEL_CTA;
  mixpanelObject[MIXPANEL_POP_UP_GROUP] = MIXPANEL_CONSUMPTION_SUBSCRIPTION;
  mixpanelObject[MIXPANEL_IS_SUBSCRIPTION_FLOW] = true;
  popupCTAEvent();
};
